import type { IRiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues } from './RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues.interface';

export default class RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues
  implements IRiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues {
  other: boolean;
  otherComments: string;
  isAnythingToBeExcludedOrLimitedInOurDiscussions: boolean;
  isAnythingToBeExcludedOrLimitedInOurDiscussionsComments: string;
  anyOtherObjectivesTasksOrItemsYouWouldLikeToDiscuss: boolean;
  anyOtherObjectivesTasksOrItemsYouWouldLikeToDiscussComments: string;

  static build = (data: IRiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues) =>
    new RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues(data);

  static blank = () => new RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues();

  /**
   * Constructor
   * @param {IRiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues} data
   */
  constructor(data?: IRiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues) {
    this.other = data?.other === true;
    this.otherComments = data?.otherComments || '';
    this.isAnythingToBeExcludedOrLimitedInOurDiscussions =
      data?.isAnythingToBeExcludedOrLimitedInOurDiscussions === true;
    this.isAnythingToBeExcludedOrLimitedInOurDiscussionsComments =
      data?.isAnythingToBeExcludedOrLimitedInOurDiscussionsComments || '';
    this.anyOtherObjectivesTasksOrItemsYouWouldLikeToDiscuss =
      data?.anyOtherObjectivesTasksOrItemsYouWouldLikeToDiscuss === true;
    this.anyOtherObjectivesTasksOrItemsYouWouldLikeToDiscussComments =
      data?.anyOtherObjectivesTasksOrItemsYouWouldLikeToDiscussComments || '';
  }
}
